module.exports = __webpack_public_path__ + "assets/img/one.e677107b.png";